import { checkValidURI } from './helpers';

function checkRootLevelKeys(fvpConfig) {
	const siteId = fvpConfig['siteId'];
	const siteDomain = fvpConfig['siteDomain'];
	const mcmId = fvpConfig['mcmId'];

	if (!mcmId || typeof mcmId !== 'string') {
		throw new Error('mcmId is missing or invalid. A valid mcmId is required for tag creation.');
	}

	if (!siteId || typeof siteId !== 'number') {
		throw new Error('siteId is missing or invalid. A valid mcmId is required for tag creation.r');
	}

	if (!siteDomain || typeof siteDomain !== 'string') {
		throw new Error(
			'siteDomain is missing or invalid. A valid mcmId is required for tag creation.'
		);
	}

	validatefvpBundleScriptSplitConfig(fvpConfig?.fvpBundleScriptSplit);
	validateFallbackXmlConfig(fvpConfig?.fallbackXmlConfig);
	validateSectionLevelSplit(fvpConfig?.sectionLevelSplit);
}

function validatefvpBundleScriptSplitConfig(fvpBundleScriptSplit) {
	if (fvpBundleScriptSplit) {
		if (
			!fvpBundleScriptSplit.hasOwnProperty('enabled') ||
			typeof fvpBundleScriptSplit.enabled !== 'boolean'
		) {
			throw new Error(
				'enabled is either not found in fvpBundleScriptSplit or is not of type boolean.'
			);
		}

		if (
			!fvpBundleScriptSplit.hasOwnProperty('splits') ||
			!Array.isArray(fvpBundleScriptSplit.splits)
		) {
			throw new Error(
				'splits is either not found in fvpBundleScriptSplit or is not of type Array.'
			);
		}

		let splitsAdd = 0;

		fvpBundleScriptSplit.splits.forEach((data) => {
			if (!data.url || data.url === '' || typeof data.url !== 'string') {
				throw new Error('url is either not found in splits or is not of type string.');
			}
			checkValidURI(data.url);

			if (!data.hasOwnProperty('splitPercentage') || typeof data.splitPercentage != 'number') {
				throw new Error('splitPercentage is either not found in splits or is not of type number.');
			}

			if (
				!data.hasOwnProperty('loadVideoJsCustomStyles') ||
				typeof data.loadVideoJsCustomStyles !== 'boolean'
			) {
				throw new Error(
					'loadVideoJsCustomStyles is either not found in splits or is not of type boolean'
				);
			}
			splitsAdd += data.splitPercentage;
		});

		if (splitsAdd > 0 && splitsAdd < 100) {
			throw new Error('split percentage total should be 100 in sectionLevelSprit');
		}
	}
}

function validateFallbackXmlConfig(fallbackXmlConfig) {
	if (fallbackXmlConfig) {
		if (
			!fallbackXmlConfig.hasOwnProperty('enabled') ||
			typeof fallbackXmlConfig.enabled !== 'boolean'
		) {
			throw new Error('enabled is either not found in fallbackXmlConfig or is not of type boolean');
		}

		if (
			!fallbackXmlConfig.hasOwnProperty('vastTagUrls') ||
			!Array.isArray(fallbackXmlConfig.vastTagUrls)
		) {
			throw new Error(
				'vastTagUrls is either not found in fallbackXmlConfig or is not of type Array'
			);
		}

		if (!fallbackXmlConfig.enabled) {
			throw new Error('fallbackXmlConfig enabled must be true.');
		}

		if (fallbackXmlConfig.vastTagUrls.length === 0) {
			throw new Error('At least one URL must be present in vastTagUrls.');
		}

		fallbackXmlConfig.vastTagUrls.forEach((url, index) => {
			checkValidURI(url);
		});
	}
}

function validateSectionLevelSplit(sectionLevelSplit) {
	if (sectionLevelSplit) {
		if (
			!sectionLevelSplit.hasOwnProperty('enabled') ||
			typeof sectionLevelSplit.enabled !== 'boolean'
		) {
			throw new Error('enabled is either not found in sectionLevelSplit or is not of type boolean');
		}

		if (
			!sectionLevelSplit.hasOwnProperty('splits') ||
			typeof sectionLevelSplit.splits !== 'object'
		) {
			throw new Error('splits is either not found in sectionLevelSplit or is not of type Object');
		}

		Object.keys(sectionLevelSplit.splits).forEach((key) => {
			const split = sectionLevelSplit.splits[key];

			if (typeof split !== 'object') {
				throw new Error(`The item with key ${key} in splits is not of type Object`);
			}

			if (
				!split.hasOwnProperty('splitPercentage') ||
				typeof split.splitPercentage !== 'number' ||
				split.splitPercentage < 0 ||
				split.splitPercentage > 100
			) {
				throw new Error(
					`splitPercentage for item with key ${key} is either missing, not a number, or out of range (0-100)`
				);
			}
		});
	}
}

function validateDemandSequence(demandSequence) {
	const UNITS = ['AD_UNIT', 'VAST_TAG'];

	demandSequence.forEach((data) => {
		if (!UNITS.includes(data.type)) {
			throw new Error(
				'type is missing in demandSequence. It must be either "AD_UNIT" or "VAS_TAG".'
			);
		}

		if (!data.data || typeof data.data !== 'string') {
			throw new Error('demandSequence data must be a non-empty string.');
		}
		console.log(data.name);
		if (!data.name || typeof data.name !== 'string') {
			throw new Error('demandSequence name must be a non-empty string.');
		}
	});
}

function validateNetworkConfig(networkData, videoSectionId) {
	if (!networkData || typeof networkData !== 'object') {
		throw new Error('networkData is either not found in fvpConfig or is not of type object');
	}

	if (!networkData.hasOwnProperty('demandSequence') || !Array.isArray(networkData.demandSequence)) {
		throw new Error(
			`demandSequence key is missing or not a type of Array at videoSection: ${videoSectionId}`
		);
	}

	validateDemandSequence(networkData.demandSequence);

	if (!networkData.demandSelectionOrder || typeof networkData.demandSelectionOrder !== 'string') {
		throw new Error(
			`demandSelectionOrder is either not found in networkData, is not of type string, or is an empty string at videoSection: ${videoSectionId}`
		);
	}

	if (
		!networkData.hasOwnProperty('globalHbDisabled') ||
		typeof networkData.globalHbDisabled != 'boolean'
	) {
		throw new Error(
			`globalHbDisabled is either not found in networkData or is not of type boolean at videoSection: ${videoSectionId}`
		);
	}

	if (!networkData.hasOwnProperty('hbFloor') || typeof networkData.hbFloor != 'number') {
		throw new Error(
			`hbFloor is either not found in fvpConfig or is not of type number at videoSection: ${videoSectionId}`
		);
	}

	if (
		!networkData.hasOwnProperty('globalHbDisabled') ||
		typeof networkData.globalHbDisabled != 'boolean'
	) {
		throw new Error(
			`globalHbDisabled is either not found in networkData or is not of type boolean at videoSection: ${videoSectionId}`
		);
	}

	validateUamConfig(networkData?.uamConfig, videoSectionId);
}

function validateRequestStructureData(requestStructureData, videoSectionId) {
	if (typeof requestStructureData !== 'object' || requestStructureData === null) {
		throw new Error('requestStructureData should be an object');
	}

	if (
		typeof requestStructureData.filledRetryInterval !== 'number' ||
		!requestStructureData.hasOwnProperty('filledRetryInterval')
	) {
		throw new Error(
			`filledRetryInterval is missing in requestStructureData or not a number  at ${videoSectionId}`
		);
	}

	if (
		typeof requestStructureData.unfilledRetryInterval !== 'number' ||
		!requestStructureData.hasOwnProperty('unfilledRetryInterval')
	) {
		throw new Error(
			`unfilledRetryInterval is missing in requestStructureData or not a number  at ${videoSectionId}`
		);
	}

	if (
		typeof requestStructureData.requestBatchSize !== 'number' ||
		!requestStructureData.hasOwnProperty('requestBatchSize')
	) {
		throw new Error(
			`requestBatchSize is missing in requestStructureData or not a number at ${videoSectionId}`
		);
	}

	if (
		typeof requestStructureData.maxNumberOfBatches !== 'number' ||
		!requestStructureData.hasOwnProperty('maxNumberOfBatches')
	) {
		throw new Error(
			`maxNumberOfBatches is missing in requestStructureData or not a number at ${videoSectionId}`
		);
	}
}

function validateFeaturesData(featuresData, videoSectionId) {
	if (!featuresData || typeof featuresData !== 'object') {
		throw new Error('featuresData is either not found in fvpConfig or is not of type object ');
	}

	if (
		featuresData.hasOwnProperty('unmuteAfterInteractionConfig') &&
		typeof featuresData.unmuteAfterInteractionConfig == 'object'
	) {
		if (
			!featuresData.unmuteAfterInteractionConfig.hasOwnProperty('enabled') ||
			typeof featuresData.unmuteAfterInteractionConfig.enabled != 'boolean'
		) {
			throw new Error(
				`enabled is either not found in unmuteAfterInteractionConfig or is not of type boolean at videoSectionId: ${videoSectionId}`
			);
		}
	}
}

function validateUamConfig(uamConfig, videoSectionId) {
	if (typeof uamConfig !== 'object' || uamConfig === null) {
		throw new Error('uamConfig type should be object');
	}
	if (!uamConfig.hasOwnProperty('enabled') || typeof uamConfig.enabled !== 'boolean') {
		throw new Error(
			`enabled is either not found in uamConfig or is not of type boolean at videoSection: ${videoSectionId}`
		);
	}

	if (
		!uamConfig.hasOwnProperty('publisherId') ||
		uamConfig.publisherId === '' ||
		typeof uamConfig.publisherId !== 'string'
	) {
		throw new Error(
			`publisherId is either not found in uamConfig or is not of type string at videoSection: ${videoSectionId}`
		);
	}

	if (
		!uamConfig.hasOwnProperty('uamSlotId') ||
		uamConfig.uamSlotId === '' ||
		typeof uamConfig.uamSlotId !== 'string'
	) {
		throw new Error(
			`uamSlotId is either not found in uamConfig or is not of type string at videoSection: ${videoSectionId}`
		);
	}
}

// this is a temporary fix where we will avoid checking the requestStructureData, networkConfig and featuresData for waterfall case, as we are not using them 
function checkFvpConfig(fvpConfig) {
	const isWaterfall = fvpConfig?.fallbackXmlConfig?.enabled && fvpConfig?.fallbackXmlConfig?.vastTagUrls?.length > 0;
	checkRootLevelKeys(fvpConfig);
	const videoSections = Object.keys(fvpConfig?.ads);
	if (videoSections.length === 0) {
		throw new Error('Atleast one videoSection is mandatory in ads config');
	}

	videoSections.forEach((videoSectionId) => {
		const videoSection = fvpConfig.ads[videoSectionId];
		!isWaterfall && validateRequestStructureData(videoSection?.requestStructureData, videoSection?.videoSectionId);
		!isWaterfall && validateFeaturesData(videoSection?.featuresData, videoSection?.videoSectionId);
		!isWaterfall && validateNetworkConfig(videoSection?.networkData, videoSection?.videoSectionId);
	});
}

export default checkFvpConfig;
